// *******************************************************************************************
// ge-9x-hero script
// *******************************************************************************************
function textTransformAnimation() {
  var reveals = document.querySelectorAll(".sec");
  for (var i = 0; i < reveals.length; i++) {
    var windowHeight = window.innerHeight;
    var elementTop = reveals[i].getBoundingClientRect().top;
    var elementVisible = 300;
    if (elementTop < windowHeight - elementVisible) {
      reveals[i].classList.add("active");
    } else {
      reveals[i].classList.remove("active");
    }
  }
}

function heroSecHeight() {
  let hero = document.querySelector(".hero-sec");
  // if(hero.length){}
  let winScrollY = window.scrollY;
  let eleHeight = hero.offsetHeight;
  if (eleHeight <= winScrollY) {
    document.querySelector(".video-wrap").style.display = "none";
    document.querySelector(".video-bg-opacity").style.display = "none";
  } else {
    document.querySelector(".video-wrap").style.display = "block";
    document.querySelector(".video-bg-opacity").style.display = "block";
  }

}

window.addEventListener(
  "scroll",
  function () {
    let opacityDiv = document.querySelector(".video-bg-opacity");
    if (opacityDiv && opacityDiv != null) {
    let elementHeight = opacityDiv.clientHeight;
    let videoBg = document.querySelector(".video-bg");
    let scrollTop = window.pageYOffset;
    let sec1Height = this.document.querySelector('.sec-1');

    if (scrollTop > 100) {
      // videoBg.style.setProperty("-webkit-filter", `blur(${scrollTop / 150}px)`);
      opacityDiv.style.setProperty("opacity", `${1 - (elementHeight - scrollTop) / (elementHeight + 1000)}`);
    } else {
      // videoBg.style.setProperty("-webkit-filter", `inherit`);
      opacityDiv.style.setProperty("opacity", `0.4`);
    }
    // Text Transform animation for hero
    textTransformAnimation()
    heroSecHeight();
  }
  },
  false
);

// counter countup for GE9x Hero

class countUpBg {
  constructor(el) {
    this.el = el;
    this.setVars();
    this.init();
  }

  setVars() {
    this.number = this.el.querySelectorAll("[data-countup-number]");
    this.observerOptions = { root: null, rootMargin: "0px 0px", threshold: 0 };
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const end = parseFloat(
          entry.target.dataset.countupNumber.replace(/,/g, "")
        );
        const decimals = this.countDecimals(end);
        if (entry.isIntersecting) {
          this.iterateValue(entry.target, end, decimals);
        }
      });
    }, this.observerOptions);
  }

  init() {
    if (this.number.length > 0) {
      this.number.forEach((el) => {
        this.observer.observe(el);
      });
    }
  }

  iterateValue(el, end, decimals) {
    const start = 0;
    const duration = 1200;
    let startTimestamp = null;

    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const elapsedPercent = (timestamp - startTimestamp) / duration;
      const easedProgress = Math.min(this.easeOutQuint(elapsedPercent), 1);
      let interimNumber = Math.abs(easedProgress * (end - start) + start);
      el.innerHTML = this.formatNumber(interimNumber, decimals);
      if (easedProgress < 1) {
        window.requestAnimationFrame(step);
      }
    };

    // requestAnimationFrame returns DOMHighResTimeStamp as a callback (used as timestamp)
    window.requestAnimationFrame(step);
  }

  easeOutQuad(x) {
    return 1 - Math.pow(1 - x, 3);
  }

  easeOutQuint(x) {
    return 1 - Math.pow(1 - x, 5);
  }

  countDecimals(val) {
    if (Math.floor(val) === val) return 0;
    return val.toString().split(".")[1].length || 0;
  }

  formatNumber(val, decimals) {
    return val.toLocaleString("en-US", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  }
}

// Simplifed version of Viget dynamic modules to attach instances for this demo
// https://www.viget.com/articles/how-does-viget-javascript/
// You CAN use this pattern, but it's single purpose right now
const dataModules = [...document.querySelectorAll('[data-module="countup"]')];

dataModules.forEach((element) => {
  element.dataset.module.split(" ").forEach(function () {
    new countUpBg(element);
  });
});

// *******************************************************************************************
// end GE9x Hero script
// *******************************************************************************************
// model hero 

/*******************************************************************************
  ** Start of Modal functionality
  *******************************************************************************/
(function ($) {
  $(document).ready(function () {
    // Gets the video src from the data-src on each button
    var $videoSrc;
    $('.watch-btn').click(function () {
      $videoSrc = $(this).data("src");
    });
    // console.log($videoSrc);
    // when the modal is opened autoplay it
    $('.ge-modal-brand-launch-hero').on('shown.bs.modal', function (e) {
      // set the video src to autoplay and not to show related video. Youtube related video is like a box of chocolates... you never know what you're gonna get
      $(".ge-modal-brand-launch-hero iframe").attr('src', $videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0");
    })
    // stop playing the youtube video when I close the modal
    $('.ge-modal-brand-launch-hero').on('hide.bs.modal', function (e) {
      // a poor man's stop video
      $(".ge-modal-brand-launch-hero iframe").attr('src', $videoSrc);
    })
    // document ready
  });
})(jQuery);


/*******************************************************************************
** End of Modal functionality
*******************************************************************************/

